<script>
    import {colors} from '../store';
</script>

<symbol id="move1" viewBox="0 0 10 10">
    <polygon points="5,0, 0,5, 3,5, 3,10, 7,10, 7,5, 10,5" fill="{$colors.gray[900]}" />
</symbol>

<symbol id="move2" viewBox="0 0 10 10">
    <polygon points="5,3, 0,8, 3,8, 3,10, 7,10, 7,8, 10,8" fill="{$colors.gray[900]}" />
    <polygon points="5,0, 0,5, 0,7, 5,2, 10,7, 10,5" fill="{$colors.gray[900]}" />
</symbol>

<symbol id="clockwise" viewbox="0 0 10 10">
    <path d="M 8 5 h 2 l -3 3 l -3 -3 h 2 a 2 2 0 1 0 -2 2 v 2 A 4 4 0 1 1 8 5" fill="{$colors.gray[900]}" />
</symbol>

<symbol id="anticlockwise" viewbox="0 0 10 10">
    <use xlink:href="#clockwise" x="0" y="0" width="10" height="10" transform="scale(-1, 1) translate(-10, 0)" />
</symbol>

<symbol id="shoot" viewbox="0 0 10 10">
    <circle cx="5" cy="5" r="3" fill="{$colors.gray[900]}" />
</symbol>

<symbol id="player" viewbox="0 0 10 10">
    <rect x="0" y="0" width="10" height="10" fill="{$colors.gray[900]}" />
    <circle cx="2" cy="2" r="1" fill="{$colors.gray[100]}" />
    <circle cx="8" cy="2" r="1" fill="{$colors.gray[100]}" />
</symbol>
